/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'bot-management-match-readonly';
const prefix = `${moduleName}.${componentName}`;

export const botManagementLabel = `${prefix}.botManagementLabel`;

export const ENGLISH = {
    [botManagementLabel]: 'Bot Management',
};
